import {useCommunity} from "ubcommunity-shared/src/Community/CommunityProvider/CommunityProvider";
import {AdminFeatureFlags} from "ubcommunity-shared/src/constants";

export function useIsFeatureAdminEnabled(feature: AdminFeatureFlags): boolean {
    const {selectedCommunity} = useCommunity();

    return selectedCommunity?.settings?.[feature];
}
